module.exports = __webpack_public_path__ + "static/media/aumenta-ventas.633922c6.svg";